import { ChequePrintTemplates } from "features/ChequePrintTemplates/ChequePrintTemplates";

import styles from "./styles.module.scss";

export const ChequePrintTemplatesPage = (): JSX.Element => (
  <div className={styles.main}>
    <ChequePrintTemplates />
  </div>
);
